var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 7.98428L12.528 4.18195C11.6454 3.49534 10.4094 3.49534 9.52684 4.18195L4.63734 7.98428C4.04188 8.44735 3.69374 9.15954 3.69409 9.91386V16.5139C3.69409 17.5264 4.5149 18.3472 5.52743 18.3472H16.5274C17.5399 18.3472 18.3608 17.5264 18.3608 16.5139V9.91386C18.3608 9.15945 18.0124 8.4472 17.4166 7.98428",
    stroke: "#23272E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 13.7501C12.6408 14.972 9.35725 14.972 7.33325 13.7501",
    stroke: "#23272E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardB);
export default __webpack_public_path__ + "static/media/DashboardB.9c7bd71a0929da3b3b3867648da4a973.svg";
export { ForwardRef as ReactComponent };